import React, {
  SelectHTMLAttributes,
  useEffect,
  useRef,
  useState,
  useCallback,
} from 'react';
import { Flex } from '@chakra-ui/react';
import { IconBaseProps } from 'react-icons';
import { useField } from '@unform/core';
import { FiAlertCircle } from 'react-icons/fi';

import { Container, Error } from './styles';

interface LojaDATA {
  id: string;
  nome: string;
  url_avatar: string;
  url_page: string;
  fantazia: string;
  fone: string;
  endereco: {
    cep: string;
    uf: string;
    cid: string;
    cidcod: string;
    bai: string;
    endereco: string;
    num: string;
    comp: string;
    formatted_address: string;
    location: {
      lat: number;
      lng: number;
    };
  };
}
interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  name: string;
  icon?: React.ComponentType<IconBaseProps>;
  containerStyle?: object;
  options: LojaDATA[];
  placeholder: string;
}

const InputSelectEmp: React.FC<SelectProps> = ({
  name,
  icon: Icon,
  options,
  placeholder,
  containerStyle,
  ...rest
}) => {
  const inputRef = useRef<HTMLSelectElement>(null);
	const iconRef = useRef<any>(null);

  const [isFocused, setIsFocused] = useState(false);
  const [isField, setIsField] = useState(false);
  const { fieldName, defaultValue, error, registerField } = useField(name);

  const handleInputFocus = useCallback(() => {
    setIsFocused(true);
  }, []);

  const handleInputBlur = useCallback(() => {
    setIsFocused(false);
    setIsField(!!inputRef.current?.value);
  }, []);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
    });
  }, [fieldName, registerField]);

  return (
    <Container
      isErrored={!!error}
      isField={isField}
      isFocused={isFocused}
      style={containerStyle}
    >
      {Icon && <Icon />}
      <select
        onFocus={handleInputFocus}
        onBlur={handleInputBlur}
        defaultValue={defaultValue}
        ref={inputRef}
        {...rest}
      >
        <option value="" disabled>
          {placeholder}
        </option>

        {options.map((item, indice) => (
          <option key={indice} value={item.id}>
            {item.fantazia}
          </option>
        ))}
      </select>

      {error && (
				<Error title={error}>
					<Flex pr={1} ref={iconRef}>
						<FiAlertCircle color="#c53030" size={20} />
					</Flex>
				</Error>
      )}
    </Container>
  );
};

export default InputSelectEmp;
